var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkout-summary" },
    [
      !_vm.hideVenueInfo
        ? _c("checkout-venue-info", { staticClass: "hidden-sm hidden-xs" })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("items"),
      _vm._v(" "),
      _vm.booking
        ? _c(
            "div",
            { staticClass: "booking-summary" },
            [
              _vm.showPaymentBreakdown
                ? _c(
                    "div",
                    { staticClass: "booking-breakdown" },
                    [
                      _vm.booking.payment !==
                      _vm.BOOKING_PAYMENT_TYPES.ADVANCE_DEPOSIT
                        ? _c("div", { staticClass: "line subtotal " }, [
                            _c("p", { staticClass: "name" }, [
                              _vm._v("\n          Subtotal\n        "),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value number-display" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("venueCurrency")(
                                      _vm.booking.price,
                                      _vm.venue.currencyCode,
                                      _vm.venue.languageCode
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.booking.payment ===
                      _vm.BOOKING_PAYMENT_TYPES.ADVANCE_DEPOSIT
                        ? _c("div", { staticClass: "line " }, [
                            _c("p", { staticClass: "name" }, [
                              _vm._v("\n          Deposit\n        "),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value number-display" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("venueCurrency")(
                                      _vm.booking.price,
                                      _vm.venue.currencyCode,
                                      _vm.venue.languageCode
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.booking.tax > 0
                        ? _c("div", { staticClass: "line " }, [
                            _c("p", { staticClass: "name" }, [
                              _vm._v(
                                "\n          Tax (" +
                                  _vm._s(
                                    _vm._f("percent")(_vm.booking.taxPercent)
                                  ) +
                                  ")\n        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value number-display" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("venueCurrency")(
                                      _vm.booking.tax,
                                      _vm.venue.currencyCode,
                                      _vm.venue.languageCode
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.booking.tip > 0
                        ? _c("div", { staticClass: "line " }, [
                            _c("p", { staticClass: "name" }, [
                              _vm._v(
                                "\n          Service charge (" +
                                  _vm._s(
                                    _vm._f("percent")(_vm.booking.tipPercent)
                                  ) +
                                  ")\n        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value number-display" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("venueCurrency")(
                                      _vm.booking.tip,
                                      _vm.venue.currencyCode,
                                      _vm.venue.languageCode
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.booking.fees, function (fee) {
                        return _vm.booking.fees && _vm.booking.fees.length
                          ? _c("div", { staticClass: "line " }, [
                              _c("p", { staticClass: "name" }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(fee.name) +
                                    "\n          "
                                ),
                                fee.type === "PERCENT"
                                  ? _c("span", [
                                      _vm._v(
                                        "\n            (" +
                                          _vm._s(
                                            _vm._f("percent")(
                                              _vm._f("roundNumber")(fee.amount)
                                            )
                                          ) +
                                          ")\n          "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n            (" +
                                          _vm._s(
                                            _vm._f("roundNumber")(fee.amount)
                                          ) +
                                          ")\n          "
                                      ),
                                    ]),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "value number-display" }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm._f("venueCurrency")(
                                        fee.value,
                                        _vm.venue.currencyCode,
                                        _vm.venue.languageCode
                                      )
                                    ) +
                                    "\n        "
                                ),
                              ]),
                            ])
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.booking.discounts, function (discount) {
                        return _vm.booking.discounts &&
                          _vm.booking.discounts.length
                          ? _c("div", { staticClass: "line discount" }, [
                              _c("p", { staticClass: "name" }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(discount.name) +
                                    "\n        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "value number-display" }, [
                                _vm._v(
                                  "\n          -" +
                                    _vm._s(
                                      _vm._f("venueCurrency")(
                                        discount.value,
                                        _vm.venue.currencyCode,
                                        _vm.venue.languageCode
                                      )
                                    ) +
                                    "\n        "
                                ),
                              ]),
                            ])
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm.isDispensary
                        ? _c("div", { staticClass: "tax-info-line" }, [
                            _c("i", {
                              staticClass: "icon ion-information-circled",
                            }),
                            _vm._v(
                              "\n        The tax amount we provide is an estimate and is subject to change. Final taxes will be adjusted when you pay for your order.\n      "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("discount-form"),
              _vm._v(" "),
              _vm.showPaymentBreakdown
                ? _c("div", { staticClass: "booking-total" }, [
                    _c("div", { staticClass: "total" }, [
                      _c("p", { staticClass: "name" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.subtotalText) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "value number-display" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("venueCurrency")(
                                _vm.booking.totalWithCredit,
                                _vm.venue.currencyCode,
                                _vm.venue.languageCode
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.booking.payment ===
                    _vm.BOOKING_PAYMENT_TYPES.ADVANCE_DEPOSIT
                      ? _c("div", { staticClass: "due-at-venue" }, [
                          _c("p", { staticClass: "name" }, [
                            _vm._v(
                              "\n          Estimated balance due at the venue\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "value number-display" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("venueCurrency")(
                                    _vm.booking.dueOnArrival,
                                    _vm.venue.currencyCode,
                                    _vm.venue.languageCode
                                  )
                                ) +
                                "\n        "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("checkout-btn"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "booking-powered-by hidden-sm hidden-xs" },
        [_c("powered-by")],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/CheckoutSummary/template.html?vue&type=template&id=09ae8803&
// module id = 1039
// module chunks = 0